module.exports = __webpack_public_path__ + "static/media/slider3.5bff9630.jpg";